import * as React from 'react'
import { FormProvider } from 'react-hook-form'

import { FieldPicker } from './FieldPicker'

export const FormBuilder = ({
  fields,
  formHeader,
  form,
  onSubmit,
  register,
  children,
  setFieldValue,
  className,
  errors,
  jsonFieldOnForm,
}) => {
  const allFieldTypes = fields?.map(field => field.type)
  const errorsDivRef = React.useRef(null)
  const recaptchaRef = React.useRef()
  if (allFieldTypes?.includes('captchaVerification') && !recaptchaRef) {
    throw new Error(
      'You must provide a recaptchaRef when using the captchaVerification field type',
    )
  }

  React.useEffect(() => {
    if (errors) {
      errorsDivRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  })

  return (
    <FormProvider {...form}>
      {formHeader}
      <form
        onSubmit={onSubmit}
        style={{
          width: '100%',
          gap: '16px',
          display: 'flex',
          flexDirection: 'column',
        }}
        className={className}
      >
        {fields?.map((field, index) => (
          <FieldPicker
            register={register}
            recaptchaRef={recaptchaRef}
            setFieldValue={setFieldValue}
            jsonFieldOnForm={jsonFieldOnForm}
            getValues={form.getValues}
            control={form.control}
            key={`${field.name}-${index}`}
            error={form.formState.errors[field.name]}
            {...field}
          />
        ))}
        {children}
      </form>
      {errors && (
        <div
          ref={errorsDivRef}
          style={{
            fontSize: 16,
            color: 'red',
            textAlign: 'center',
          }}
        >
          {errors}
        </div>
      )}
    </FormProvider>
  )
}

export default FormBuilder
